<div>
  <div class="tag-search__sub-header copy" [class.tag-search__sub-header--large]="ppHasLargeTitle">
    <p>{{ 'including_tags' | ppTranslate }}</p>

    @if (filters?.tags?.value?.length > 0 || filters?.tags?.combinedTags) {
      <button class="filterDropdown__clear--text" (click)="clearAll()">
        {{ 'clear' | ppTranslate }}
      </button>
    }
  </div>

  <pp-tag-select
    ppClass="tagSelect__auto-width"
    [ppSelectedTags]="filters?.tags?.value"
    (ppOnChange)="selectTags($event)"
    [ppWorkspaceId]="workspaceId"
    [ppOptions]="tagSelectOptionsForInclude"
    (ppOnClose)="selectTags($event)"
    [attr.data-test]="'includingTagsInput'"
  ></pp-tag-select>
</div>

<div>
  <div
    class="tag-search__sub-header copy tag-search__sub-header--marginTop"
    [class.tag-search__sub-header--large]="ppHasLargeTitle"
  >
    <p>{{ 'excluding_tags' | ppTranslate }}</p>

    @if (filters?.excludedTags?.value?.length > 0 || filters?.excludedTags?.combinedTags) {
      <button class="filterDropdown__clear--text" (click)="clearAllExcluded()">
        {{ 'clear' | ppTranslate }}
      </button>
    }
  </div>

  <pp-tag-select
    ppClass="tagSelect__auto-width"
    [ppSelectedTags]="filters?.excludedTags?.value"
    (ppOnChange)="selectExcludedTags($event)"
    (ppOnClose)="selectExcludedTags($event)"
    [ppWorkspaceId]="workspaceId"
    [ppOptions]="tagSelectOptionsForExclude"
    [attr.data-test]="'excludingTagsInput'"
  ></pp-tag-select>
</div>
